import './component.scss'
import { Controller } from 'stimulus'

// CloudFrontのキャッシュにより、サーバーサイドで絞り込み条件を反映したHTMLが返らないため、
// クライアントサイドでURLパラメータを読み取り、モーダル内のHTMLから動的に表示テキストを構築する
window.Stimulus.register(
  'filter-search-button',
  class extends Controller {
    static targets = ['label', 'value']

    connect() {
      this._updateDisplayFromParams()
    }

    _updateDisplayFromParams() {
      const params = new URLSearchParams(window.location.search)
      const labels = []

      const singleValueKeys = ['review_rating', 'review_count', 'construction_count', 'established_years']
      const multiValueKeys = ['building_types[]', 'wall_materials[]', 'themes[]', 'insurance_types[]', 'available_services[]', 'qualifications[]', 'preferences[]']

      singleValueKeys.forEach(key => {
        const value = params.get(key)
        if (value) {
          const label = this._findLabelInModal(key, value)
          if (label) labels.push(label)
        }
      })

      multiValueKeys.forEach(key => {
        const values = params.getAll(key)
        values.forEach(value => {
          const label = this._findLabelInModal(key, value)
          if (label) labels.push(label)
        })
      })

      if (labels.length === 0) {
        this._showNoFilters()
      } else {
        this._showFilters(labels.join(' / '))
      }
    }

    _findLabelInModal(key, value) {
      const modal = document.querySelector('.filter-search-modal')
      if (!modal) return null

      const selector = `input[name="${key}"][value="${value}"], input[name="${key}[]"][value="${value}"]`
      const input = modal.querySelector(selector)
      if (!input) return null

      const sectionPrefix = this._getSectionPrefix(input)
      const labelElement = input.closest('label')
      if (!labelElement) return null

      const labelText = labelElement.textContent.trim()
      return sectionPrefix ? `${sectionPrefix}${labelText}` : labelText
    }

    _getSectionPrefix(input) {
      const gridGroup = input.closest('.filter-search-modal__grid-group, .filter-search-modal__checkbox-group, .filter-search-modal__expandable')
      if (!gridGroup) return null

      const sectionLabel = gridGroup.previousElementSibling
      if (!sectionLabel || !sectionLabel.classList.contains('filter-search-modal__label')) return null

      const sectionText = sectionLabel.textContent.trim()
      return input.type === 'radio' ? `${sectionText}：` : null
    }

    _showNoFilters() {
      if (this.hasLabelTarget) this.labelTarget.style.display = ''
      this.valueTarget.textContent = '指定なし'
      this.valueTarget.classList.remove('filter-search__value--has-filters')
    }

    _showFilters(text) {
      if (this.hasLabelTarget) this.labelTarget.style.display = 'none'
      this.valueTarget.textContent = text
      this.valueTarget.classList.add('filter-search__value--has-filters')
    }
  }
)
